import { useState } from 'react'
import { Typography, IconButton, Divider, MenuItem, TextField, Button } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'
import axios from 'axios'
import { userTypesList } from '../lists'
import './AddUserDrawer.css'

interface AddUserDrawerProps {
  onUserAdded: () => void
  onError: (error: { show: boolean; displayName: string }) => void
  onClose: () => void
}

function AddUserDrawer({ onUserAdded, onError, onClose }: AddUserDrawerProps) {
  const [newUser, setNewUser] = useState({
    userType: '',
    displayName: '',
    email: '',
  })

  const handleAddUser = () => {
    if (!newUser.userType || !newUser.displayName || !newUser.email) {
      alert('Please fill in all required fields')
      return
    }

    // Map new frontend role names to old backend role names/IDs
    let backendUserType = newUser.userType
    if (newUser.userType === 'Operations') {
      backendUserType = 'Operation Staff'
    } else if (newUser.userType === 'Sales') {
      backendUserType = 'Sales Rep'
    } else if (newUser.userType === 'Read Only') {
      backendUserType = 'Office Staff'
    }

    const requestData = {
      user: {
        user_type: backendUserType,
        display_name: newUser.displayName,
        email: newUser.email,
        active_flag: true,
      },
    }

    axios
      .post('/newUser', requestData)
      .then(() => {
        setNewUser({
          userType: '',
          displayName: '',
          email: '',
        })
        onUserAdded()
        onClose()
      })
      .catch(error => {
        console.error('Error creating user:', error)
        onError({ show: true, displayName: newUser.displayName })
      })
  }

  return (
    <div className="add-user-drawer">
      <div className="add-user-drawer-header">
        <div>
          <Typography variant="h6">Add User</Typography>
          <IconButton onClick={onClose}>
            <ArrowForward />
          </IconButton>
        </div>
        <Divider />
      </div>
      <div className="add-user-form-container">
        <TextField
          label="Role"
          value={newUser.userType}
          select
          size="small"
          fullWidth
          onChange={e => setNewUser(prev => ({ ...prev, userType: e.target.value }))}
        >
          {userTypesList.map(type => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </TextField>
        <div className="add-user-form-grid">
          <TextField
            label="Full Name"
            value={newUser.displayName}
            onChange={e => setNewUser(prev => ({ ...prev, displayName: e.target.value }))}
            size="small"
          />
          <TextField
            label="Email"
            type="email"
            value={newUser.email}
            onChange={e => setNewUser(prev => ({ ...prev, email: e.target.value }))}
            size="small"
          />
        </div>
        <Button
          variant="contained"
          onClick={handleAddUser}
          disabled={!newUser.userType || !newUser.displayName || !newUser.email}
        >
          Save and Add User
        </Button>
      </div>
    </div>
  )
}

export default AddUserDrawer
